module.exports = __webpack_public_path__ + "static/media/box.e4688b03.svg";